<template>
    <!-- <div class="copyright">
        Copyright © 2026 <span class="copyrightText">技术支持：北京华科软通科技有限公司 </span>
        京ICP备16027592号-3
    </div> -->
</template>

<script>
export default {
    name: 'CommonFooter'
}
</script>

<style scoped>
.copyright {
    font-family: SourceHanSansCN-Light, SourceHanSansCN-Light;
    font-weight: normal;
    font-size: 12px;
    color: #999999;
    line-height: 21px;
    text-align: center;
    position: fixed;
    bottom: 10px;
    width: 100%;
}

.copyrightText {
    margin: 0 20px;
}
</style>
